'use client';
import { useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const DualAudienceSection = () => {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals?.length) return;

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    );
    reveals?.forEach((el) => observer?.observe(el));
  }, []);

  return (
    <section className="py-24 bg-muted">
      <div className="container px-6">
        <div className="max-w-2xl mx-auto">
          {/* Students Section */}
          <div className="bg-card rounded-2xl p-6 sm:p-8 md:p-12 border border-border shadow-sm reveal">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                <Icon name="UserIcon" size={20} className="sm:w-6 sm:h-6 text-primary" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-foreground">For Students</h3>
            </div>

            <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mb-4 sm:mb-6">
              Prepare for your aviation exams with flexible study sessions, instant feedback, and comprehensive
              explanations.
            </p>

            <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              <li className="flex items-start gap-2 sm:gap-3">
                <Icon name="CheckCircleIcon" size={18} className="text-success mt-0.5 sm:w-5 sm:h-5" />
                <span className="text-sm sm:text-base text-foreground">Choose topics you need to focus on</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <Icon name="CheckCircleIcon" size={18} className="text-success mt-0.5 sm:w-5 sm:h-5" />
                <span className="text-sm sm:text-base text-foreground">Study with explanations or test yourself</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <Icon name="CheckCircleIcon" size={18} className="text-success mt-0.5 sm:w-5 sm:h-5" />
                <span className="text-sm sm:text-base text-foreground">Track progress across all categories</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <Icon name="CheckCircleIcon" size={18} className="text-success mt-0.5 sm:w-5 sm:h-5" />
                <span className="text-sm sm:text-base text-foreground">Save and resume study sessions</span>
              </li>
            </ul>

            <Link
              href="/student-dashboard"
              className="inline-flex items-center justify-center w-full px-6 py-3 text-xs sm:text-sm font-semibold text-primary-foreground bg-primary rounded-full hover:bg-primary/90 transition-colors"
            >
              Go to Student Dashboard
              <Icon name="ArrowRightIcon" size={14} className="ml-2 sm:w-4 sm:h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DualAudienceSection;